var React = require('react');

function Oval2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","opacity":".163","transform":"translate(-81 3.68)"},[React.createElement("circle",{"cx":"115","cy":"18.32","r":"22","fill":"#FFF","strokeOpacity":".466","strokeWidth":"8","key":0}),React.createElement("circle",{"cx":"115","cy":"18.32","r":"26","strokeOpacity":".497","strokeWidth":"16","key":1})]));
}

Oval2.defaultProps = {"width":"68","height":"56","viewBox":"0 0 68 56"};

module.exports = Oval2;

Oval2.default = Oval2;



// WEBPACK FOOTER //
// ./src/Assets/Icons/oval-2.svg